const affectedOptions = [
  { value: 'campaigns', content: 'Campaigns', group: 'affected' },
  { value: 'publishers', content: 'Publishers', group: 'affected' },
  { value: 'sources', content: 'ZeroPark Sources', group: 'affected' },
  { value: 'keywords', content: 'ZeroPark Keywords', group: 'affected' },
  { value: 'channels', content: 'Channels', group: 'affected' },
  { value: 'creatives', content: 'Creatives', group: 'affected' },
  { value: 'domains', content: 'Rtx Domains', group: 'affected' },
  { value: 'subids', content: 'Rtx SubIds', group: 'affected' },
];

const typeOptions = [
  { value: 'rule', content: 'Rule', group: 'type' },
  { value: 'manual', content: 'Manual', group: 'type' },
  { value: 'system', content: 'System', group: 'type' },
];

const errorOptions = [
  { value: 'completed', content: 'Completed', group: 'status' },
  { value: 'failed', content: 'Failed', group: 'status' },
  { value: 'nochanges', content: 'No Changes', group: 'status' },
];

const logOptions = [
  { value: 'all', content: 'Show Info Logs', group: 'log' },
  { value: 'false', content: 'Hide Info Logs', group: 'log' },
];

export { affectedOptions, typeOptions, errorOptions, logOptions };
